<div appDynamicScreenHeight *ngIf="(borrowerLoading$ | async) else content" class="tw-grid tw-items-center">
  <mat-spinner class="tw-m-auto" diameter="48"></mat-spinner>
</div>
<ng-template #content>
  <div *ngIf="(borrower$ | async) as borrower">
    <div class="tw-p-4">
      <div class="tw-grid tw-grid-flow-col tw-justify-between">
        <h2 class="mb-0 tw-pl-2">
          <a interactive target="_blank" [routerLink]="['/borrower/' + borrower.id]"> {{borrower.name}} </a>
        </h2>
        <div class="tw-grid tw-items-center">
          <app-borrower-status-display-smart [mode]="'display'"></app-borrower-status-display-smart>
        </div>
      </div>
      <div class="tw-pl-2 tw-pb-3">
        <app-borrower-doing-business-as-name [borrowerValues]="borrower.borrower_values"></app-borrower-doing-business-as-name>
      </div>
      <div class="tw-pl-2">
        <app-application-complete-status [applicationComplete]="(applicationComplete$ | async)"></app-application-complete-status>
        <mat-chip-listbox *ngIf="(fundingNeeds$ | async)">
          <mat-chip [disableRipple]="true" class="!tw-bg-amber-600 !tw-text-white">Submission Snapshot</mat-chip>
        </mat-chip-listbox>
      </div>
    </div>
    <mat-tab-group
      #tabs
      [selectedIndex]="selectedTabIndex"
      appDynamicScreenHeight
    >

    <mat-tab label="Overview">
      <ng-template matTabContent>
        <app-borrower-pane-overview></app-borrower-pane-overview>
      </ng-template>
    </mat-tab>

      <mat-tab label="Activity">
        <ng-template matTabContent>
          <borrower-activity-stream [borrower]="borrower" [simplified]="true"></borrower-activity-stream>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="canViewBorrowerPaneDeals$ | async" label="Deals">
        <ng-template matTabContent>
          <app-borrower-pane-deals
            [borrowerId]="borrower.id">
          </app-borrower-pane-deals>
        </ng-template>
      </mat-tab>

    <mat-tab label="Documents">
      <ng-template matTabContent>
        <app-documents-smart
          [borrower]="borrower"
          [compactView]="true"
          [tableColumns]="['title','category', 'createdTimestamp']"
          [showActions]="false"
          [showUploadedBy]="false"
          [defaultPageSize]="10"
          [showPageSizeOptions]="false"
        ></app-documents-smart>
      </ng-template>
    </mat-tab>

      <mat-tab label="Notes">
        <ng-template matTabContent>
          <app-notes-smart
            [borrowerId]="borrower.id">
          </app-notes-smart>
        </ng-template>
      </mat-tab>

    </mat-tab-group>
  </div>
</ng-template>
